import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivitiesServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { forkJoin, ReplaySubject, Subject } from '@node_modules/rxjs';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { takeUntil } from '@node_modules/rxjs/operators';

@Component({
    selector: 'personnel-table-filter',
    templateUrl: './personnel-table-filter.component.html',
    styleUrls: ['./personnel-table-filter.component.less']
})
export class PersonnelTableFilterComponent extends AppComponentBase implements OnInit {
    filterText;

    locations;
    companies;
    trades;

    constructor(
        injector: Injector,
        private _activitiesServiceProxy: ActivitiesServiceProxy,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
    }
    @Output() onFiltersChange: EventEmitter<any> = new EventEmitter<any>();

    public locationFormCtrl: FormControl = new FormControl();
    public locationFilterFormCtrl: FormControl = new FormControl();
    public filteredLocation: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    public companyFormCtrl: FormControl = new FormControl();
    public companyFilterFormCtrl: FormControl = new FormControl();
    public filteredCompany: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    

    protected _onDestroy = new Subject<void>();

    ngOnInit(): void {
        const editData = forkJoin({
            locations: this._activitiesServiceProxy.getPersonnelLocations(),
            companies: this._activitiesServiceProxy.getPersonnelCompanies(),
        });
        editData.subscribe((data) => {
            this.filteredLocation.next(data.locations.slice());
            this.filteredCompany.next(data.companies.slice());

            this.locations = data.locations;
            this.companies = data.companies;
        });
        this.initiateFiltersValueChanges();
    }
    private initiateFiltersValueChanges() {
        this.locationFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterLocations();
            });

        this.companyFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterCompanies();
            });
    }
    refresh() {
        this.filtersChange();
    }
    clear(){
        this.filterText = null;
        this.locationFormCtrl.reset();
        this.companyFormCtrl.reset();
        this.filtersChange();
    }
    filtersChange() {
        const params = {
            filterText: this.filterText,
            location: this.locationFormCtrl.value || null,
            company: this.companyFormCtrl.value || null,
        };

        this.onFiltersChange.emit(params);
    }


    protected filterLocations() {
        if (!this.locations) {
            return;
        }

        let search = this.locationFilterFormCtrl.value;
        if (!search) {
            this.filteredLocation.next(this.locations.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredLocation.next(
            this.locations?.filter(
                (location) => location.locationName.toLowerCase().indexOf(search) > -1
            )
        );
    }

    protected filterCompanies() {
        if (!this.companies) {
            return;
        }

        let search = this.companyFilterFormCtrl.value;
        if (!search) {
            this.filteredCompany.next(this.companies.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredCompany.next(
            this.companies?.filter(
                (company) => company.company.toLowerCase().indexOf(search) > -1
            )
        );
    }

    loadControlling(location, option) {

    }
}
